import { Pipe, PipeTransform } from '@angular/core';

/**
 * Transforms the data to show only top three items by priority defined in priorityList object.
 */
@Pipe({ name: 'evShowTopThree',  pure: false })
export class ShowTopThreePipe implements PipeTransform {
  public priorityList: object = {
    customerNumber: 1,
    firstName: 2,
    lastName: 2,
    company: 3,
    emailAdvanced: 4,
    tixx_invoice_number: 5,
    birthday: 6,
    street: 7,
    postalCode: 8,
    city: 9, // town
    country: 10,
    types: 11 // type of address
  };

  /**
   * Transforms data to show only top three items by priority
   *
   * @param value Value passed to this method via pipe in template
   * @param args Any additional arguments
   */
  public transform(value: any, args: Array<any> = null): any {
    const topThree = {};
    let isFirstOrLastName = false;
    for (const key of Object.keys(value)) {
      if (this.priorityList[key]) {
        if (key === 'firstName' || key === 'lastName') {
          isFirstOrLastName = true;
        }
        topThree[value[key]] = this.priorityList[key];
      }
    }

    const sliceFrom = 0;
    const sliceToIfNoName = 2;
    const sliceToIfName = 3;
    const sliceTo = isFirstOrLastName ? sliceToIfName : sliceToIfNoName;

    return Object.keys(topThree).sort((a, b) => topThree[a] - topThree[b]).slice(sliceFrom, sliceTo);
  }
}
